import { useTranslation } from 'react-i18next';

const WHATSAPP_NUMBER = '6593651286';

const BookingSection = () => {
  const { t, i18n } = useTranslation('common');

  const services = t('booking.services', { returnObjects: true }) as string[];

  const buildWhatsAppUrl = (service?: string) => {
    const msg = service
      ? encodeURIComponent(
          i18n.language === 'zh'
            ? `你好，我想预约${service}疗愈服务，请问有哪些时间可以安排？`
            : `Hello, I would like to book a ${service} session. What times are available?`
        )
      : encodeURIComponent(
          i18n.language === 'zh'
            ? '你好，我想预约疗愈服务，请问有哪些时间可以安排？'
            : 'Hello, I would like to book a healing session. What times are available?'
        );
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`;
  };

  return (
    <section id="booking" className="py-14 md:py-24 bg-white">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
        {/* Header */}
        <div className="mb-8 md:mb-14">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full bg-teal-50 mb-4 md:mb-6">
            <i className="ri-calendar-check-line text-2xl md:text-3xl text-teal-700"></i>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-stone-800 mb-2 md:mb-3">{t('booking.title')}</h2>
          <p className="text-stone-500 text-sm md:text-base">{t('booking.subtitle')}</p>
        </div>

        {/* WhatsApp Card */}
        <div className="rounded-2xl border border-teal-100 bg-teal-50/50 p-6 md:p-10 flex flex-col items-center gap-6 md:gap-8">
          {/* Number display */}
          <div className="flex items-center gap-4 md:gap-5">
            <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-[#25D366] rounded-full shadow-lg">
              <i className="ri-whatsapp-line text-white text-2xl md:text-3xl"></i>
            </div>
            <div className="text-left">
              <p className="text-xs text-stone-400 uppercase tracking-widest mb-1">WhatsApp</p>
              <p className="text-xl md:text-3xl font-semibold text-teal-700">+65 9365 1286</p>
            </div>
          </div>

          {/* Quick booking by service */}
          <div className="w-full">
            <p className="text-sm text-stone-500 mb-3 md:mb-4">{t('booking.quickBook')}</p>
            <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-3">
              {Array.isArray(services) && services.map((service) => (
                <a
                  key={service}
                  href={buildWhatsAppUrl(service)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-1.5 md:gap-2 px-3 py-2.5 md:px-4 md:py-3 bg-white border border-teal-200 text-teal-700 rounded-xl text-xs md:text-sm font-medium hover:bg-teal-700 hover:text-white hover:border-teal-700 transition-all duration-200 cursor-pointer"
                >
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-sm md:text-base"></i>
                  </div>
                  <span className="truncate">{service}</span>
                </a>
              ))}
            </div>
          </div>

          {/* General booking button */}
          <a
            href={buildWhatsAppUrl()}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center justify-center gap-2 md:gap-3 py-3.5 md:py-4 bg-[#25D366] hover:bg-[#1ebe5d] text-white rounded-full text-sm md:text-base font-semibold transition-all duration-300 hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg md:text-xl"></i>
            </div>
            {t('booking.generalButton')}
          </a>

          <p className="text-xs text-stone-400">{t('booking.hint')}</p>
        </div>
      </div>
    </section>
  );
};

export default BookingSection;
